import React from "react";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import SecurityIcon from "@mui/icons-material/Security";

export interface CategoryMapping {
  apiValue: string;
  displayLabel: string;
  icon: React.ReactElement<any>;
}

export const awsRecommendationsCategoryMap: Record<string, CategoryMapping> = {
  "Cost Management": {
    apiValue: "Cost Management",
    displayLabel: "Cost",
    icon: React.createElement(LocalAtmIcon, { fontSize: "small" }),
  },
  "Security & Compliance": {
    apiValue: "Security & Compliance",
    displayLabel: "Security",
    icon: React.createElement(SecurityIcon, { fontSize: "small" }),
  },
};

export const getAwsCategoryIcon = (
  apiCategory: string,
): React.ReactElement<any> | null => {
  return awsRecommendationsCategoryMap[apiCategory]?.icon || null;
};

export const getAwsCategoryDisplayLabel = (apiCategory: string): string => {
  return (
    awsRecommendationsCategoryMap[apiCategory]?.displayLabel || apiCategory
  );
};

export const getAwsOrderedCategories = (): string[] => {
  return ["Security & Compliance", "Cost Management"];
};
